module.exports = __webpack_public_path__ + "assets/img/f5e3-cf.svg";